import React, { useEffect, useState } from 'react';
import styles from './CookieConsent.module.css';
import { useTranslation } from 'react-i18next';
import Button from '../ui/Button';

const CookieConsent = () => {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      //setTimeout(() => setVisible(true), 1500); // slight delay to appear smoothly
    }
  }, []);

  const handleConsent = (agree) => {
    localStorage.setItem('cookieConsent', agree ? 'accepted' : 'declined');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className={styles.cookieBar}>
      <p>
        This site uses cookies to enhance your debate experience and for analytics. By continuing, you agree to our{' '}
        <a href="/privacy" target="_blank" rel="noopener noreferrer">{t('ui.privacyPolicy')}</a>.
      </p>
      <div className={styles.actions}>
        <Button variant="primary" className={styles.accept} onClick={() => handleConsent(true)}>
          Accept
        </Button>
        <Button variant="secondary" className={styles.decline} onClick={() => handleConsent(false)}>
          Decline
        </Button>
      </div>
    </div>
  );
};

export default CookieConsent;
